import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

const initialState = {
    value: {
        produk_pilihan: "",
        detail_order: [],
        promo_usage: [],
        data_promo: [],
        free_order: [],
        total_belanja: 0,
        total_bayar: 0,
        total_potongan: 0,
        kurir_transaksi: {},
        voucher: [],
        method_delivery: 0,
        customer_data: {
            cust_address: "",
            cust_name: "",
            cust_no: "",
            cust_no_hp: "",
            id_voucher: "",
            identity_code: "",
            identity_data: "",
            status_ref: "",
            vooche_title: "",
            voucher_customer_id: "",
            voucher_description: "",
        },
        payment_method: "",
        detail_order_return: [],
        total_belanja_return: 0,
        order_no: "",
    },
};

const transaksiSlice = createSlice({
    name: "Transaksi",
    initialState,
    reducers: {
        /**
         * Set the chosen product for the transaction
         * @param {object} a the action payload
         * @param {string} a.payload.produk_pilihan the chosen product
         */
        chooseProdukPilihan: (s, a) => {
            s.value.produk_pilihan = a.payload.produk_pilihan;
        },
        /**
         * Adds a detail order to the list. If the product already exists in the list,
         * it increments the quantity and updates the total basic price. Alerts the user
         * if the quantity exceeds the stock and the item is not allowed to have negative stock.
         * If the item is not allowed to have negative stock, it also prevents adding more than
         * one quantity of a new item.
         *
         * @param {Object} s - The state object containing the detail order list.
         * @param {Object} a - The action object containing the detail order to be added.
         */

        // addDetailOrder: (s, a) => {
        // const payload = a.payload.detail_order;
        // console.log("Tambah produk:", payload);

        // // --- Cari produk existing berdasarkan pcode, uom, conv ---
        // const index = s.value.detail_order.findIndex(
        //     (item) =>
        //     item.pcode === payload.pcode &&
        //     item.uom === payload.uom 
        //     // &&
        //     // item.conv === payload.conv
        // );

        // // --- Kalau produk sudah ada di cart ---
        // if (index !== -1) {
        //     const currentItem = s.value.detail_order[index];

        //     // Validasi stok jika tidak boleh minus
        //     if (currentItem.qty >= currentItem.stock && !currentItem.allow_minus) {
        //     return alert(
        //         "Maaf produk ini tidak bisa ditambahkan,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
        //     );
        //     }

        //     // Gabung qty lama + baru
        //     currentItem.qty = Number(currentItem.qty) + Number(payload.qty);

        //     // --- Hitung ulang harga sesuai tier ---
        //     transaksiSlice.caseReducers.calculatebasic_price(s, {
        //     qty: currentItem.qty,
        //     pricetag: currentItem.price_details,
        //     index,
        //     calculation_type: currentItem.calculation_type,
        //     });
        // }

        // // --- Kalau produk belum ada di cart ---
        // else {
        //     const newItem = { ...payload };

        //     // Hitung harga awal berdasarkan tier
        //     transaksiSlice.caseReducers.calculatebasic_price(s, {
        //     qty: newItem.qty,
        //     pricetag: newItem.price_details,
        //     index: s.value.detail_order.length, // index baru
        //     calculation_type: newItem.calculation_type,
        //     });

        //     s.value.detail_order.push(newItem);
        // }

        // // Reset pilihan produk setelah tambah
        // s.value.produk_pilihan = "";
        // },


        // calculatebasic_price: (s, a) => {
        // const { qty, pricetag, index, calculation_type } = a;

        // // Pastikan index valid
        // if (index < 0 || index >= s.value.detail_order.length) return;

        // const item = s.value.detail_order[index];

        // if (!Array.isArray(pricetag) || pricetag.length === 0) return;

        // // --- Cari tier harga berdasarkan qty ---
        // const applicableTier = pricetag
        //     .filter((tier) => qty >= tier.min_qty)
        //     .sort((a, b) => b.min_qty - a.min_qty)[0] || pricetag[0];

        // // --- Set harga per pcs dan total ---
        // const eachPrice = Number(applicableTier.price);
        // const totalPrice = eachPrice * qty;
        // const totalBasic = Number(applicableTier.basic_price) * qty;

        // item.eachPrice = eachPrice;
        // item.price = totalPrice;
        // item.total_basic_price = totalBasic;

        // // --- Kalau calculation_type ada perhitungan khusus ---
        // if (calculation_type === 2) {
        //     // Contoh: tambahkan diskon, margin, atau perhitungan promo
        //     // item.price -= (item.discount || 0);
        // }

        // s.value.detail_order[index] = item;
        // },


        // addDetailOrder: (s, a) => {
        //     let payload = a.payload.detail_order;
        //     console.log({payload})

        //     function getIndex(pcode, pcode_name, uom, conv) {
        //         return s.value.detail_order.findIndex(
        //             (i) =>
        //                 i.pcode === pcode &&
        //                 i.pcode_name === pcode_name &&
        //                 i.uom === uom &&
        //                 i.conv === conv
        //         );
        //     }

        //     let index = getIndex(
        //         payload.pcode,
        //         payload.pcode_name,
        //         payload.uom,
        //         payload.conv
        //     );

        //     if (index !== -1) {
        //         if (
        //             s.value.detail_order[index].qty >=
        //                 s.value.detail_order[index].stock &&
        //             !s.value.detail_order[index].allow_minus
        //         )
        //             return alert(
        //                 "Maaf produk ini tidak bisa ditambahkan,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
        //             );
        //         s.value.detail_order[index].qty =
        //             Number(s.value.detail_order[index].qty) +
        //             Number(payload.qty);
        //         s.value.detail_order[index].total_basic_price += Number(
        //             payload.total_basic_price
        //         );

        //         let detail_order = s.value.detail_order;
        //         transaksiSlice.caseReducers.calculatebasic_price(s, {
        //             qty: detail_order[index].qty,
        //             pricetag: detail_order[index].price_details,
        //             uom: detail_order[index].uom,
        //             uom_a: detail_order[index].uom_a,
        //             conv: detail_order[index].conv,
        //             index: index,
        //             calculation_type: detail_order[index].calculation_type,
        //         });
        //         s.value.produk_pilihan = "";
        //     } else {
        //         if (
        //             !a.payload.detail_order.allow_minus &&
        //             a.payload.detail_order.qty > 1
        //         )
        //             return alert(
        //                 "Maaf produk ini tidak bisa ditambahkan melebihi 1 kuantiti ,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
        //             );
        //         s.value.detail_order.push(a.payload.detail_order);
        //         s.value.produk_pilihan = "";
        //     }
        // },
        addDetailOrder: (s, a) => {
            let payload = a.payload.detail_order;
            console.log({payload})

            function getIndex(pcode, pcode_name,min_qty) {
                return s.value.detail_order.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        Number(i.min_qty) == Number(min_qty)
                );
            }

            let index = getIndex(
                payload.pcode,
                payload.pcode_name,
                payload.min_qty
            );

            console.log({index});

            if (index !== -1) {
                let item = s.value.detail_order[index];

                if ((Number(item.qty) >= Number(item.stock)) && !item.allow_minus)
                    return alert(
                        "Maaf produk ini tidak bisa ditambahkan,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
                );

                let qty_setelah_ditambah = Number(item.qty) + Number(payload.qty);

                item.qty = Number(item.qty) + Number(payload.qty);
                item.total_basic_price += Number(payload.total_basic_price);

                // ini nyari data product di cart untuk dapetin yang nilai min_qty nya sama dengan qty baru
                let index_is_exist = getIndex(
                    payload.pcode,
                    payload.pcode_name,
                    qty_setelah_ditambah
                );

                if(index_is_exist !== -1){
                    let item_is_exist = s.value.detail_order[index_is_exist];
                    item_is_exist.qty += qty_setelah_ditambah;
                    item_is_exist.total_basic_price += (item.total_basic_price + Number(payload.total_basic_price));
                    item.qty -= qty_setelah_ditambah;
                    item.total_basic_price -= Number(payload.total_basic_price);
                    transaksiSlice.caseReducers.calculatebasic_price(s, {
                        qty: item_is_exist.qty,
                        pricetag: item_is_exist.price_details,
                        uom: item_is_exist.uom,
                        uom_a: item_is_exist.uom_a,
                        conv: item_is_exist.conv,
                        min_qty: item_is_exist.min_qty,
                        index: index_is_exist,
                        calculation_type: item_is_exist.calculation_type,
                    });
                }else{
                    transaksiSlice.caseReducers.calculatebasic_price(s, {
                        qty: item.qty,
                        pricetag: item.price_details,
                        uom: item.uom,
                        uom_a: item.uom_a,
                        conv: item.conv,
                        min_qty: item.min_qty,
                        index: index,
                        calculation_type: item.calculation_type,
                    });
                }

                if(item.qty == 0) s.value.detail_order.splice(index, 1);

                
            } else {
                if (!payload.allow_minus && (Number(payload.qty) > Number(payload.stock)))
                    return alert(
                        "Maaf produk ini tidak bisa ditambahkan melebihi 1 kuantiti ,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
                    );

                s.value.detail_order.push(payload);
            }

            s.value.produk_pilihan = "";
        },

        /**
         * Adds a detail order to the return list. If the product already exists in the list,
         * it increments the quantity and updates the total basic price. Alerts the user if the
         * quantity exceeds the stock and the item is not allowed to have negative stock.
         *
         * @param {Object} s - The state object containing the detail order return list.
         * @param {Object} a - The action object containing the detail order to be added.
         */

        addDetailOrderReturn: (s, a) => {
            let payload = a.detail_order;

            function getIndex(pcode, pcode_name) {
                let index = s.value.detail_order_return.findIndex(
                    (i) => i.pcode == pcode && i.pcode_name == pcode_name
                );
                return index;
            }

            let index = getIndex(payload.pcode, payload.pcode_name);

            if (index !== -1) {
                if (
                    s.value.detail_order_return[index].qty >=
                        s.value.detail_order_return[index].stock &&
                    !s.value.detail_order_return[index].allow_minus
                )
                    return alert(
                        "Maaf produk ini tidak bisa ditambahkan,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
                    );
                s.value.detail_order_return[index].qty =
                    Number(s.value.detail_order_return[index].qty) +
                    Number(payload.qty);
                s.value.detail_order_return[index].total_basic_price += Number(
                    payload.total_basic_price
                );
            } else {
                s.value.detail_order_return.push(a.payload.detail_order);
            }
        },

        /**
         * Removes a product from the detail order list or moves it between
         * detail order and detail order return lists based on the action type.
         *
         * Logs relevant payload information for debugging.
         *
         * - If the action type is "batal-return", it removes the product from
         *   the detail order return list and adds it back to the detail order list,
         *   then recalculates the totals for both return and order.
         *
         * - If the action type is "return", it checks if the product is already
         *   in the detail order return list. If not, it adds the product to this list
         *   and recalculates the total return.
         *
         * - If the product is found in the detail order list, it removes it and
         *   recalculates the total order.
         *
         * @param {Object} s - The state object containing the detail order lists.
         * @param {Object} a - The action object containing the payload with product details and type.
         */

        removeDetailOrder: (s, a) => {
            if (a.payload.type === "all") {
                s.value.detail_order_return = [];
                s.value.total_belanja_return = 0;
                return;
            }

            let index = s.value.detail_order.findIndex(
                (i) =>
                    i.pcode === a.payload.pcode &&
                    i.min_qty === a.payload.min_qty
            );

            if (index !== -1) {
                if (a.payload.type === "batal-jual") {
                    s.value.detail_order.splice(
                        s.value.detail_order.findIndex(
                            (i) =>
                                i.pcode === a.payload.pcode &&
                                i.min_qty == a.payload.min_qty
                        ),
                        1
                    );
                }

                if (a.payload.type === "return") {
                    let returnIndex = s.value.detail_order_return.findIndex(
                        (i) =>
                            i.pcode === a.payload.pcode &&
                            i.pcode_name === a.payload.pcode_name &&
                            i.price === a.payload.price
                    );

                    if (returnIndex !== -1) {
                        transaksiSlice.caseReducers.addDetailOrderReturn(s, {
                            detail_order: a.payload.data_product,
                        });
                        transaksiSlice.caseReducers.countTotalReturn(s);
                    } else {
                        s.value.detail_order_return.push(
                            a.payload.data_product
                        );
                        transaksiSlice.caseReducers.countTotalReturn(s);
                    }
                    s.value.detail_order.splice(
                        s.value.detail_order.findIndex(
                            (i) =>
                                i.pcode === a.payload.pcode &&
                                i.price == a.payload.price
                        ),
                        1
                    );
                }

                transaksiSlice.caseReducers.countTotalOrder(s);
            }

            if (a.payload.type === "batal-return") {
                let qty = 0;
                let indexReturn = s.value.detail_order_return.findIndex(
                    (i) =>
                        i.pcode === a.payload.pcode && i.price === a.payload.price
                );

                if (indexReturn === -1) {
                    s.value.detail_order.push(a.payload.data_product);
                } else {
                    if (indexReturn !== -1 && index !== -1) {
                        qty = s.value.detail_order_return[indexReturn].qty;
                        s.value.detail_order[index].qty = s.value.detail_order[index].qty + qty;
                    } else {
                        s.value.detail_order.push({
                        uom: a.payload.data_product.uom,
                        order_no: a.payload.data_product.order_no,
                        retail_id: a.payload.customer_id,
                        total_basic_price: a.payload.data_product.min_qty !== 1 ? (a.payload.data_product.min_qty* a.payload.data_product.price) : (1 * a.payload.data_product.price),
                        qty: a.payload.data_product.min_qty !== 1 ? a.payload.data_product.min_qty : 1,
                        price: a.payload.data_product.price,
                        price_uom: a.payload.data_product.price_uom,
                        basic_price: a.payload.data_product.basic_price,
                        pcode_name: a.payload.data_product.pcode_name,
                        is_return: a.payload.is_return,
                        pcode: a.payload.data_product.pcode,
                        img: a.payload.data_product.img,
                        min_qty: a.payload.data_product.min_qty,
                        uom_a: a.payload.data_product.uom_a,
                        uom_b: a.payload.uom_b,
                        });
                    }
                }

                s.value.detail_order_return.splice(
                    s.value.detail_order_return.findIndex(
                        (i) => i.pcode === a.payload.pcode && i.price === a.payload.price
                    ),
                    1
                );

                transaksiSlice.caseReducers.countTotalReturn(s);
                transaksiSlice.caseReducers.countTotalOrder(s);
            }
        },
        /**
         * Calculates the total shopping amount by summing up the total basic prices
         * of all items in the detail order list and updates the total_belanja field
         * in the state.
         *
         * @param {Object} s - The state object containing the detail order list and total_belanja field.
         */

        countTotalOrder: (s) => {
            s.value.total_belanja = 0;
            for (let i of s.value.detail_order) {
                s.value.total_belanja += Number(i.total_basic_price);
            }
            transaksiSlice.caseReducers.handlePromo(s);
        },
        /**
         * Calculates the total return amount by summing up the total basic prices
         * of all items in the detail order return list and updates the total_belanja_return field
         * in the state.
         *
         * @param {Object} s - The state object containing the detail order return list and total_belanja_return field.
         */
        countTotalReturn: (s) => {
            s.value.total_belanja_return = 0;
            for (let i of s.value.detail_order_return) {
                s.value.total_belanja_return += Number(i.total_basic_price);
            }
        },
        calculatebasic_price: (s, a) => {
            let totalPrice = 0;
            let newQty = a.qty,
                initQty = a.qty;
            let itunganHarga = 0;

            // it is for sorting before filtering for tiering price
            let data_price = a.pricetag.sort((a, b) => a.min_qty - b.min_qty);

            if (a.calculation_type === 2 || a.calculation_type === null) {
                console.log(
                    "=======================TIERING=========================="
                );
                let dataSorting = data_price
                    .filter((i) => initQty >= i.min_qty)
                    .sort((a, b) => a.min_qty - b.min_qty); //buat dapatin posisi tier harga
                let lastIndex = dataSorting.length - 1;
                console.log({dataSorting})
                itunganHarga = initQty * dataSorting[lastIndex].price;

                totalPrice += itunganHarga;

                s.value.detail_order[a.index].total_basic_price = totalPrice;

                transaksiSlice.caseReducers.countTotalOrder(s, a);
            } else {
                function calculatingPrice(pricetag, nqty) {
                    let getQty = Math.floor(nqty / pricetag.min_qty);
                    if (getQty !== 0) {
                        itunganHarga =
                            getQty * pricetag.min_qty * pricetag.price;
                        totalPrice += itunganHarga;
                        newQty -= getQty * pricetag.min_qty;
                    }
                }

                let index = data_price.findIndex((i) => i.min_qty == a.min_qty);

                if (index == -1)
                    data_price.push({
                        min_qty: 1,
                        price: data_price[0].price,
                        basic_price: data_price[0].basic_price,
                    });

                for (let i = data_price.length - 1; i >= 0; i--) {
                    console.log(`${data_price[i]} -X- ${newQty}`);
                    if (newQty >= data_price[i].min_qty) {
                        calculatingPrice(data_price[i], newQty);
                    }
                }

                s.value.detail_order[a.index].total_basic_price = totalPrice;

                transaksiSlice.caseReducers.countTotalOrder(s, a);
            }
        },
        /**
         * Decreases the quantity of an item in the detail order list.
         * If the quantity reaches 1, it does not decrease anymore.
         * It calculates the total basic price of the item based on its quantity and price details.
         * It updates the total basic price in the detail order list and recalculates the total order.
         * @param {Object} a - The action payload containing the item details (pcode, pcode_name, qty, price_details, index).
         */
        decreaseQty: (s, a) => {
            function getIndex(pcode, pcode_name, min_qty) {
                let index = s.value.detail_order.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        Number(i.min_qty) === Number(min_qty)
                );
                return index;
            }

            let detail_order = s.value.detail_order;

            let index = getIndex(
                a.payload.pcode,
                a.payload.pcode_name,
                a.payload.min_qty
            );

            if (index !== -1) {
                if (detail_order[index].qty == 1) return;
                detail_order[index].qty = Number(detail_order[index].qty) - Number(detail_order[index].min_qty);

                transaksiSlice.caseReducers.calculatebasic_price(s, {
                    qty: detail_order[index].qty,
                    pricetag: detail_order[index].price_details,
                    uom: detail_order[index].uom,
                    uom_a: detail_order[index].uom_a,
                    conv: detail_order[index].conv,
                    min_qty: detail_order[index].min_qty,
                    index: index,
                    calculation_type: detail_order[index].calculation_type,
                });
            }
        },
        increaseQty: (s, a) => {
            function getIndex(pcode, pcode_name, min_qty) {
                let index = s.value.detail_order.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        Number(i.min_qty) === Number(min_qty)
                );
                return index;
            }

            let detail_order = s.value.detail_order;

            let index = getIndex(
                a.payload.pcode,
                a.payload.pcode_name,
                a.payload.min_qty
            );

            if (index !== -1) {
                if (
                    detail_order[index].qty >= detail_order[index].stock &&
                    !detail_order[index].allow_minus
                )
                    return alert(
                        "Maaf produk ini tidak bisa ditambahkan,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
                    );
                
                let item = detail_order[index];

                let qty_setelah_ditambah = Number(item.qty) + item.min_qty;
                
                detail_order[index].qty = Number(item.qty) + item.min_qty;
                
                let index_is_exist = getIndex(
                    item.pcode,
                    item.pcode_name,
                    qty_setelah_ditambah
                );

                if(index_is_exist !== -1){
                    let item_is_exist = s.value.detail_order[index_is_exist];
                    item_is_exist.qty += qty_setelah_ditambah;
                    item_is_exist.total_basic_price += (item.total_basic_price + Number(item.total_basic_price));
                    item.qty -= qty_setelah_ditambah;
                    item.total_basic_price -= Number(item.total_basic_price);
                    transaksiSlice.caseReducers.calculatebasic_price(s, {
                        qty: item_is_exist.qty,
                        pricetag: item_is_exist.price_details,
                        uom: item_is_exist.uom,
                        uom_a: item_is_exist.uom_a,
                        conv: item_is_exist.conv,
                        min_qty: item_is_exist.min_qty,
                        index: index_is_exist,
                        calculation_type: item_is_exist.calculation_type,
                    });
                }else{
                    transaksiSlice.caseReducers.calculatebasic_price(s, {
                        qty: item.qty,
                        pricetag: item.price_details,
                        uom: item.uom,
                        uom_a: item.uom_a,
                        conv: item.conv,
                        min_qty: item.min_qty,
                        index: index,
                        calculation_type: item.calculation_type,
                    });
                }

                if(item.qty == 0) s.value.detail_order.splice(index, 1);

                // transaksiSlice.caseReducers.calculatebasic_price(s, {
                //     qty: detail_order[index].qty,
                //     pricetag: detail_order[index].price_details,
                //     uom: detail_order[index].uom,
                //     uom_a: detail_order[index].uom_a,
                //     conv: detail_order[index].conv,
                //     min_qty: detail_order[index].min_qty,
                //     index: index,
                //     calculation_type: detail_order[index].calculation_type,
                // });
            }
        },
        // increaseQty: (s, a) => {
        //     function getIndex(pcode, pcode_name, uom, min_qty) {
        //         return s.value.detail_order.findIndex(
        //             (i) =>
        //                 i.pcode == pcode &&
        //                 i.pcode_name == pcode_name &&
        //                 i.uom == uom &&
        //                 i.min_qty == min_qty
        //         );
        //     }

        //     let detail_order = s.value.detail_order;
        //     let payload = a.payload;

        //     let index = getIndex(payload.pcode, payload.pcode_name, payload.uom, payload.min_qty);
        //     if (index === -1) return;

        //     let currentItem = detail_order[index];

        //     // 🚫 Cek stok
        //     if (currentItem.qty >= currentItem.stock && !currentItem.allow_minus)
        //         return alert(
        //             "Maaf produk ini tidak bisa ditambahkan,\nMohon atur menjadi allow minus pada master inventory untuk produk ini."
        //         );

        //     // ✅ Tambah qty
        //     currentItem.qty = Number(currentItem.qty) + 1;

        //     // 🔁 Gabung qty antar conv (dinamis)
        //     let samePcodeItems = detail_order.filter(
        //         (i) => i.pcode === payload.pcode && i.uom === payload.uom
        //     );

        //     // Urutkan conv dari besar ke kecil
        //     samePcodeItems.sort((a, b) => Number(b.min_qty) - Number(a.min_qty));

        //     // Gabungkan qty conv kecil ke conv besar jika total conv sama
        //     for (let i = 0; i < samePcodeItems.length - 1; i++) {
        //         let big = samePcodeItems[i];
        //         for (let j = i + 1; j < samePcodeItems.length; j++) {
        //             let small = samePcodeItems[j];
        //             if (Number(small.qty) * Number(small.conv) >= Number(big.conv)) {
        //                 let convFactor = Math.floor((small.qty * small.conv) / big.conv);
        //                 if (convFactor > 0) {
        //                     // ➕ Tambahkan qty ke conv besar
        //                     big.qty += big.conv;

        //                     // 🔁 Kurangi qty kecil
        //                     small.qty -= (convFactor * big.conv) / small.conv;

        //                     // 🧮 Hitung ulang harga untuk kedua item yang berubah
        //                     transaksiSlice.caseReducers.calculatebasic_price(s, {
        //                         qty: big.qty,
        //                         pricetag: big.price_details,
        //                         uom: big.uom,
        //                         uom_a: big.uom_a,
        //                         conv: big.conv,
        //                         index: getIndex(big.pcode, big.pcode_name, big.uom, big.conv),
        //                         calculation_type: big.calculation_type,
        //                     });

        //                     if(small.qty > 0){
        //                         transaksiSlice.caseReducers.calculatebasic_price(s, {
        //                             qty: small.qty,
        //                             pricetag: small.price_details,
        //                             uom: small.uom,
        //                             uom_a: small.uom_a,
        //                             conv: small.conv,
        //                             index: getIndex(small.pcode, small.pcode_name, small.uom, small.conv),
        //                             calculation_type: small.calculation_type,
        //                         });
        //                     }
        //                 }
        //             }
        //         }
        //     }

        //     // Bersihkan item dengan qty = 0
        //     s.value.detail_order = s.value.detail_order.filter((i) => i.qty > 0);

        //     // 🔢 Recalculate harga untuk item yang qty-nya ditambah
        //     index = getIndex(payload.pcode, payload.pcode_name, payload.uom, payload.conv);
        //     if (index === -1) return;

        //     currentItem = s.value.detail_order[index];

        //     transaksiSlice.caseReducers.calculatebasic_price(s, {
        //         qty: currentItem.qty,
        //         pricetag: currentItem.price_details,
        //         uom: currentItem.uom,
        //         uom_a: currentItem.uom_a,
        //         conv: currentItem.conv,
        //         index: index,
        //         calculation_type: currentItem.calculation_type,
        //     });
        // },
        // decreaseQty: (s, a) => {
        //     function getIndex(pcode, pcode_name, uom, conv) {
        //         return s.value.detail_order.findIndex(
        //             (i) =>
        //                 i.pcode == pcode &&
        //                 i.pcode_name == pcode_name &&
        //                 i.uom == uom &&
        //                 i.conv == conv
        //         );
        //     }

        //     let detail_order = s.value.detail_order;
        //     let payload = a.payload;

        //     let index = getIndex(payload.pcode, payload.pcode_name, payload.uom, payload.conv);
        //     if (index === -1) return;

        //     let currentItem = detail_order[index];

        //     if (currentItem.qty <= 1) {
        //         // kalau qty 1, hapus aja item-nya
        //         s.value.detail_order = detail_order.filter((_, i) => i !== index);
        //         return;
        //     }

        //     // kurangi qty 1
        //     currentItem.qty = Number(currentItem.qty) - 1;

        //     // total pcs berdasarkan conv besar
        //     // let totalPcs = currentItem.qty * currentItem.conv;

        //     // cek apakah total pcs tidak kelipatan conv besar → berarti perlu split
        //     let fullConvCount = Math.floor(currentItem.qty / currentItem.conv); // berapa kali conv penuh
        //     let sisaPcs = currentItem.qty % currentItem.conv; // sisanya
        //     console.log({sisaPcs})

        //     // update item conv besar ke jumlah penuh
        //     currentItem.qty = currentItem.qty - sisaPcs;

        //     // cari conv kecil
        //     let smallerConvItem = detail_order.find(
        //         (i) =>
        //             i.pcode === payload.pcode &&
        //             i.uom === payload.uom &&
        //             i.conv < payload.conv
        //     );

        //     if (sisaPcs > 0) {
        //         if (smallerConvItem) {
        //             // tambahkan sisa ke item conv kecil
        //             smallerConvItem.qty += sisaPcs;

        //             transaksiSlice.caseReducers.calculatebasic_price(s, {
        //                 qty: smallerConvItem.qty,
        //                 pricetag: smallerConvItem.price_details,
        //                 uom: smallerConvItem.uom,
        //                 uom_a: smallerConvItem.uom_a,
        //                 conv: smallerConvItem.conv,
        //                 index: getIndex(
        //                     smallerConvItem.pcode,
        //                     smallerConvItem.pcode_name,
        //                     smallerConvItem.uom,
        //                     smallerConvItem.conv
        //                 ),
        //                 calculation_type: smallerConvItem.calculation_type,
        //             });
        //         } else {
        //             // kalau belum ada conv kecil, buat baru
        //             let basePrice = currentItem.price_details.find((p) => p.min_qty === 1);
        //             detail_order.push({
        //                 ...currentItem,
        //                 conv: 1,
        //                 qty: sisaPcs,
        //                 price: basePrice.price,
        //                 eachPrice: basePrice.price,
        //                 total_basic_price: basePrice.price * sisaPcs,
        //             });
        //         }
        //     }

        //     // kalau conv besar qty 0, hapus item-nya
        //     if (currentItem.qty === 0) {
        //         s.value.detail_order = s.value.detail_order.filter((i) => i.qty > 0);
        //     } else {
        //         // hitung ulang harga conv besar
        //         transaksiSlice.caseReducers.calculatebasic_price(s, {
        //             qty: currentItem.qty,
        //             pricetag: currentItem.price_details,
        //             uom: currentItem.uom,
        //             uom_a: currentItem.uom_a,
        //             conv: currentItem.conv,
        //             index: index,
        //             calculation_type: currentItem.calculation_type,
        //         });
        //     }
        // },
        decreaseQtyReturn: (s, a) => {
            function getIndex(pcode, pcode_name, price) {
                let index = s.value.detail_order.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        i.price == price
                );
                return index;
            }

            function getIndexOrderReturn(pcode, pcode_name, price) {
                let index = s.value.detail_order_return.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        i.price == price
                );
                return index;
            }

            let detail_order = s.value.detail_order;

            let index = getIndex(
                a.payload.pcode,
                a.payload.pcode_name,
                a.payload.price
            );
            let indexReturn = getIndexOrderReturn(
                a.payload.pcode,
                a.payload.pcode_name,
                a.payload.price
            );

            if (index !== -1) {
                let detail_order_by_idx = detail_order[index];
                let price = a.payload.price;

                detail_order_by_idx.qty = Number(detail_order_by_idx.qty) - Number(detail_order_by_idx.min_qty) ;
                
                if (detail_order_by_idx.qty == 0)
                    s.value.detail_order.splice(
                        s.value.detail_order.findIndex(
                            (i) =>
                                i.pcode === detail_order_by_idx.pcode &&
                                i.price === detail_order_by_idx.price
                        ),
                        1
                    );
                
                detail_order_by_idx.total_basic_price = (Number(detail_order_by_idx.qty)) * Number(price);
                if (indexReturn !== -1) {
                    s.value.detail_order_return[indexReturn].qty =
                        Number(s.value.detail_order_return[indexReturn].qty) +
                        Number(detail_order_by_idx.min_qty);
                    s.value.detail_order_return[indexReturn].total_basic_price =
                        (Number(s.value.detail_order_return[indexReturn].qty)) *
                        Number(s.value.detail_order_return[indexReturn].price);
                    transaksiSlice.caseReducers.countTotalReturn(s);
                    transaksiSlice.caseReducers.countTotalOrder(s);
                } else {
                    s.value.detail_order_return.push({
                        uom: detail_order_by_idx.uom,
                        order_no: detail_order_by_idx.order_no,
                        retail_id: detail_order_by_idx.customer_id,
                        total_basic_price:  detail_order_by_idx.min_qty * price,
                        qty: detail_order_by_idx.min_qty !== 1 ? detail_order_by_idx.min_qty : 1,
                        price: price,
                        basic_price: detail_order_by_idx.basic_price,
                        pcode_name: detail_order_by_idx.pcode_name,
                        is_return: detail_order_by_idx.is_return,
                        pcode: detail_order_by_idx.pcode,
                        img: detail_order_by_idx.img,
                        min_qty: detail_order_by_idx.min_qty,
                        uom_a: detail_order_by_idx.uom_a,
                        uom_b: detail_order_by_idx.uom_b,
                    });
                    transaksiSlice.caseReducers.countTotalReturn(s);
                    transaksiSlice.caseReducers.countTotalOrder(s);
                }
            }
        },
        increaseQtyReturn: (s, a) => {
            function getIndex(pcode, pcode_name, price) {
                let index = s.value.detail_order.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        i.price == price
                );
                return index;
            }

            function getIndexOrderReturn(pcode, pcode_name, price) {
                let index = s.value.detail_order_return.findIndex(
                    (i) =>
                        i.pcode == pcode &&
                        i.pcode_name == pcode_name &&
                        i.price == price
                );
                return index;
            }

            let detail_order = s.value.detail_order;

            let index = getIndex(
                a.payload.pcode,
                a.payload.pcode_name,
                a.payload.price
            );
            let indexReturn = getIndexOrderReturn(
                a.payload.pcode,
                a.payload.pcode_name,
                a.payload.price
            );

            if (index !== -1) {
                let detail_order_by_idx = detail_order[index];
                let price = a.payload.price;

                //if(detail_order_by_idx.qty == 1) s.value.detail_order.splice(s.value.detail_order.findIndex((i) => i.pcode === detail_order_by_idx.pcode && i.uom === detail_order_by_idx.uom),1 )
                detail_order_by_idx.qty = Number(detail_order_by_idx.qty) + Number(detail_order_by_idx.min_qty);
                detail_order_by_idx.total_basic_price = Number(detail_order_by_idx.qty) * Number(price);

                if (indexReturn !== -1) {
                    if (s.value.detail_order_return[indexReturn].qty == 1) {
                        s.value.detail_order_return.splice(
                            s.value.detail_order_return.findIndex(
                                (i) =>
                                    i.pcode === detail_order_by_idx.pcode &&
                                    i.price === detail_order_by_idx.price
                            ),
                            1
                        );
                    } else {
                        s.value.detail_order_return[indexReturn].qty =
                            Number(
                                s.value.detail_order_return[indexReturn].qty
                            ) - Number(detail_order_by_idx.min_qty);
                        s.value.detail_order_return[
                            indexReturn
                        ].total_basic_price =
                            Number(
                                s.value.detail_order_return[indexReturn].price
                            );
                    }

                    transaksiSlice.caseReducers.countTotalReturn(s);
                } else {
                    s.value.detail_order_return.push({
                        uom: detail_order_by_idx.uom,
                        order_no: detail_order_by_idx.order_no,
                        retail_id: detail_order_by_idx.customer_id,
                        total_basic_price: price,
                        qty: detail_order_by_idx.min_qty !== 1 ? detail_order_by_idx.min_qty : 1,
                        price: price,
                        basic_price: detail_order_by_idx.basic_price,
                        pcode_name: detail_order_by_idx.pcode_name,
                        is_return: detail_order_by_idx.is_return,
                        pcode: detail_order_by_idx.pcode,
                        img: detail_order_by_idx.img,
                        min_qty: detail_order_by_idx.min_qty,
                        uom_a: detail_order_by_idx.uom_a,
                        uom_b: detail_order_by_idx.uom_b,
                    });
                    transaksiSlice.caseReducers.countTotalReturn(s);
                }
            }
        },
        addKurir: (s, a) => {
            s.value.kurir_transaksi = a.payload.kurir;
        },
        addVoucher: (s, a) => {
            let voucher = s.value.voucher;
            let idx = voucher.findIndex((i) => i.id_voucher == a);

            if (idx !== -1) {
                return s.value.voucher.splice(
                    s.value.voucher.findIndex(
                        (i) => i.id_voucher == a.payload.id_voucher
                    ),
                    1
                );
            }

            s.value.voucher.push(a.payload.voucher);
        },
        addDeliveryMethod: (s, a) => {
            s.value.method_delivery = a.payload.tag;
        },
        addPaymentMethod: (s, a) => {
            s.value.payment_method = a.payload.payment;
        },
        addCustomerData: (s, a) => {
            if (a.payload.data) {
                s.value.customer_data = a.payload.data;
            } else {
                s.value.customer_data[Object.keys(a.payload)[0]] =
                    a.payload[Object.keys(a.payload)[0]];
            }
        },
        clearCustomerData: (s, a) => {
            s.value.customer_data = {};
        },
        addDetailOrderForReturn: (s, a) => {
            s.value.detail_order = a.payload.detail_order;
            s.value.total_belanja = a.payload.total;
            s.value.customer_data = a.payload.customer_data;
        },
        emptyOrder: (s) => {
            s.value.detail_order = [];
            s.value.total_belanja = 0;
        },
        updateOrderNo: (s, a) => {
            s.value.order_no = a.payload.order_no;
        },
        handlePromo: (s, a) => {
            s.value.total_potongan = 0;
            s.value.free_order = [];
            s.value.data_promo = [];
            let detail_order = s.value.detail_order;
            for (let i of detail_order) {
                let promo = i.promo;

                if (promo && promo.length > 0) {
                    for (let j of promo) {
                        let available_budget = 0;
                        let promo_usage = s.value.promo_usage;
                        promo_usage = promo_usage.filter(
                            (i) => i.promo_id === j.id
                        );

                        if (promo_usage.length > 0) {
                            available_budget = j.budget - promo_usage[0].amount;
                        } else {
                            available_budget = j.budget;
                        }

                        if (j.type === "discount") {
                            if (
                                available_budget >=
                                i.total_basic_price * (j.discount / 100)
                            ) {
                                if (i.total_basic_price >= j.minimum_purchase) {
                                    let potongan = 0;

                                    if (j.discount && j.discount !== "0") {
                                        potongan =
                                            i.total_basic_price *
                                            (j.discount / 100);
                                    } else {
                                        let xPotongan =
                                            Math.floor(
                                                i.total_basic_price /
                                                    j.minimum_purchase
                                            ) * j.nominal_potongan;

                                        if (
                                            s.value.total_potongan <=
                                            j.maksimal_potongan
                                        ) {
                                            if (
                                                xPotongan > j.maksimal_potongan
                                            ) {
                                                potongan = j.nominal_potongan;
                                            } else {
                                                potongan = xPotongan;
                                            }
                                        }
                                    }

                                    s.value.total_potongan += potongan;

                                    s.value.data_promo.push({
                                        pcode: i.pcode,
                                        promo_id: j.id,
                                        amount:
                                            j.discount && j.discount !== "0"
                                                ? i.total_basic_price *
                                                  (j.discount / 100)
                                                : j.nominal_potongan,
                                    });
                                }
                            }
                        } else if (j.type === "buy1get1") {
                            if (available_budget >= i.total_basic_price) {
                                if (i.total_basic_price >= j.minimum_purchase) {
                                    s.value.free_order.push(i);
                                    s.value.data_promo.push({
                                        pcode: i.pcode,
                                        promo_id: j.id,
                                        amount: i.total_basic_price,
                                    });
                                }
                            }
                        }
                    }
                }
            }

            s.value.total_bayar =
                s.value.total_belanja - s.value.total_potongan;
        },
        updateDetailOrder: (s, a) => {
            s.value.detail_order = a.payload.detail_order;
            s.value.promo_usage = a.payload.promo_usage;

            transaksiSlice.caseReducers.handlePromo(s, a);
        },
        clearOrderDataReturn: (s, a) => {
           s.value = initialState.value;
        },
        clearOrderData: (s, a) => {
          s.value = initialState.value;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, (s) => {
            s.value = initialState.value;
        });
    },
});

export const {
    chooseProdukPilihan,
    addDetailOrder,
    removeDetailOrder,
    countTotalOrder,
    decreaseQty,
    increaseQty,
    decreaseQtyReturn,
    increaseQtyReturn,
    addKurir,
    addVoucher,
    addDeliveryMethod,
    calculatebasic_price,
    addCustomerData,
    addDetailOrderForReturn,
    addDetailOrderReturn,
    countTotalReturn,
    emptyOrder,
    addPaymentMethod,
    clearCustomerData,
    updateOrderNo,
    handlePromo,
    updateDetailOrder,
    clearOrderData,
    clearOrderDataReturn,
} = transaksiSlice.actions;
export default transaksiSlice.reducer;
